// extracted by mini-css-extract-plugin
export default {"selectedShisha":"SelectedShisha_selectedShisha__QeMJn","title":"SelectedShisha_title__3OH6w"};